enum LoadStatus {
    Ready = 0,
    Cancelled = 1,
    Expired = 2,
    Confirmed = 3,
    CancelledTms = 4,
    ConfirmedTms = 5,
    WaitingAcceptance = 6,
    WaitingConfirmation = 7,
    Suspended = 8,
    Planned = 9,
    NoRate = 10,
}

export default LoadStatus;
